<script lang="ts" setup>
import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import { LocationMarkerIcon, EyeIcon } from '@heroicons/vue/solid';
import { NumberModel } from '@/types';
import { applyPhoneMask } from '@/utils/number';
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';

const { modelValue } = defineProps({
    modelValue: {
        type: Object as PropType<NumberModel>,
        required: true,
    },
});

const router = useRouter();

const handleMonitorClick = () => {
    router.push({
        name: 'MonitorWhatsappCodeNumber',
        params: {
            id: modelValue.id,
        },
    });
};
</script>

<template>
    <UiPanel
        class="flex items-center justify-between px-4 py-3 transition-colors duration-150 hover:bg-white/80"
    >
        <div class="space-y-1">
            <div class="flex items-center space-x-2">
                <SVGWhatsApp class="h-4 w-4 flex-shrink-0 text-[#25D366]" />
                <div class="text-md text-primary font-semibold">
                    {{ applyPhoneMask(modelValue.number) }}
                </div>
            </div>
            <div class="flex items-center space-x-2 text-sm text-gray-500">
                <p class="flex items-center">
                    <LocationMarkerIcon
                        class="mr-1 h-4 w-4 flex-shrink-0 text-gray-400"
                        aria-hidden="true"
                    />
                    <span v-if="modelValue.city && modelValue.state">
                        {{ modelValue.city }}/{{ modelValue.state }}
                    </span>
                    <span v-else class="italic text-gray-400">
                        {{ $t('number.types.null') }}
                    </span>
                </p>
            </div>
        </div>

        <div>
            <UiButton
                variant="primary"
                text-variant="white"
                class="hover:scale-102 flex items-center space-x-1 transition-transform duration-150"
                @click="handleMonitorClick"
            >
                <EyeIcon class="mr-1 h-4 w-4" aria-hidden="true" />
                {{ $t('whatsappCode.monitor') }}
            </UiButton>
        </div>
    </UiPanel>
</template>
